var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip.label || _vm.tooltip.description)?_c('div',{staticClass:"tooltip"},[(_vm.tooltip.label)?_c('b',[_vm._v(_vm._s(_vm.tooltip.label))]):_vm._e(),(_vm.tooltip.label && _vm.tooltip.description)?_c('br'):_vm._e(),_vm._v(_vm._s(_vm.tooltip.description))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }